import React from 'react';
import moment from 'moment';
import theme from './style'
import {FormControl, Select, MenuItem, Checkbox} from '@material-ui/core';
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/core";
import translate from '../../../misc/applyTranslation'
import {useConfig} from "../../../context/configContext";
import {months} from "../../../misc/utils";

const CustomCheckbox = withStyles({
  root: {
    color: "gray", // unchecked
    "&$checked": {
      color: "black", // checked
    },
  },
  checked: {},
})(Checkbox);

const BorderSelect = (props) => {
  const config = useConfig();
  const classes = theme(config);
  const {
    items,
    selected,
    onChange,
    invalid,
    allowAll,
    placeholder,
    placeholderNS,
    invoiceDetailsSelect,
    multiple,
    chartSelect,
    monthsSelect
  } = props;

  const getItemText = item => {
    if (chartSelect) {
      if (item.text) {
        return item.text;
      } else {
        return item;
      }
    } else if (invoiceDetailsSelect) {
      return `${item.name} ${moment.unix(item.create_date).format('YYYY-MM-DD')}  ${item.number_invoices_imported_to_ropo}/${item.number_invoices}st`
    } else {
      if (item.text) {
        return item.text.replace("Year", translate("", "year_text"))
      } else if (item.month) {
        return translate("", item.month);
      } else if (item.delivery) {
        return item.delivery
      } else if (item.name) {
        return item.name;
      } else {
        return ""
      }
    }
  };

  const getItemId = item => {
    if (item.id) {
      return item.id
    } else if (item.delivery_id) {
      return item.delivery_id
    } else if (item.batch_id) {
      return item.batch_id
    } else {
      return item;
    }
  };

  const getRenderText = item => {
    if (chartSelect) {
      if (monthsSelect) {
        const result = months
          .filter(m => item.includes(String(m.id)))
          .map(m => m.text);
        return result.join(", ");
      }
    }
    return item.join(", ")
  }

  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value)
    }
  }

  return (
    <FormControl variant="outlined" className={`${classes.selectGroup} ${invalid ? classes.invalid : ''}`}>
      <Select
        className='select'
        value={!selected ? 'null' : selected}
        onChange={handleChange}
        placeholder={placeholder || 'generic_select'}
        multiple={multiple}
       /* renderValue={multiple ? selected => getRenderText(selected) : selected}*/
        {...(multiple && {
          renderValue: (selected) => getRenderText(selected),
        })}
      >
        {allowAll &&
          <MenuItem value={'null'}>{translate('', 'generic_select_all')}</MenuItem>
        }
        {!allowAll &&
          <MenuItem style={{display: 'none'}}
                    value={'null'}>{translate(placeholderNS || '', placeholder || 'generic_select')}</MenuItem>
        }
        {items && items.map(item =>
          <MenuItem key={String(getItemId(item))} disabled={item.disabled} value={String(getItemId(item))}>
            {(chartSelect && !monthsSelect) && <CustomCheckbox checked={selected.indexOf(item) > -1}/>}
            {(chartSelect && monthsSelect) && <CustomCheckbox checked={selected.indexOf(item.id.toString()) > -1} />}
            {getItemText(item)}
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
}
BorderSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  selected: PropTypes.string,
}
export default BorderSelect;
